import { defineMessages } from '@jutro/locale';

export default defineMessages({
    bridgeQuote: {
        id: 'ml.quoteandbind.compRater.wizard.step.CompRater Bridge Quote',
        defaultMessage: 'CompRater Bridge Quote'
    },
    bridgeQuoteSummary: {
        id: 'ml.quoteandbind.compRater.wizard.step.Bridge Quote Summary',
        defaultMessage: 'Bridge Quote Summary'
    },
    autoQuote: {
        id: 'ml.quoteandbind.compRater.wizard.step.Auto Quote',
        defaultMessage: 'Auto Quote'
    },
    homeQuote: {
        id: 'ml.quoteandbind.compRater.wizard.step.Home Quote',
        defaultMessage: 'Home Quote'
    },
    purchaseQuote: {
        id: 'ml.quoteandbind.compRater.wizard.step.Purchase',
        defaultMessage: 'Purchase'
    }
});
